<template>
  <div class="core-team">
    <div class="wow fadeInUp" style="display: flex;align-items: center;flex-direction: column;">
      <div class="title">核心团队</div>
    </div>
    <div style="margin: 6rem 0 4rem;width: 100%;">
      <div class="core-team-content" style="margin-bottom: 4rem;">
        <div class="content">
          <div class="menu">
            <div @click="openPersonDetail(item)" class="item wow fadeInUp" v-for="item in coreTeams.slice(0,3)">
              <div class="item-wrapper">
                <img class="img-fluid" :src="item.icon">
                <div class="note">
                  <span class="name">{{item.name}}</span>
                  <span class="identity">{{item.identity}}</span>
                </div>
              </div>
              <div class="triangle-up" v-if="activePerson.name == item.name"></div>
            </div>
          </div>
        </div>
        <div style="margin: 2.25rem 0 1.5rem 0;">
          <div class="peroson" id="person">
            <img style="margin-top:-0.15rem" class="img-fluid" :src="activePerson.bigImg">
            <div class="detail">
              <div class="name">{{activePerson.name}}</div>
              <div class="identity">全线通{{activePerson.identity}}</div>
              <div class="achievement">
                <p v-for="item in activePerson.achievement">{{item}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="core-team-content">
        <div class="content">
          <div class="menu">
            <div @click="openPersonDetail1(item)" class="item wow fadeInUp" v-for="item in coreTeams.slice(3)">
              <div class="item-wrapper">
                <img class="img-fluid" :src="item.icon">
                <div class="note">
                  <span class="name">{{item.name}}</span>
                  <span class="identity">{{item.identity}}</span>
                </div>
              </div>
              <div class="triangle-up" v-if="activePerson1.name == item.name"></div>
            </div>
          </div>
        </div>
        <div style="margin: 2.25rem 0 1.5rem 0;">
          <div class="peroson" id="person1">
            <img style="margin-top:-0.15rem" class="img-fluid" :src="activePerson1.bigImg">
            <div class="detail">
              <div class="name">{{activePerson1.name}}</div>
              <div class="identity">全线通{{activePerson1.identity}}</div>
              <div class="achievement">
                <p v-for="item in activePerson1.achievement">{{item}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs'

  export default {
    name: 'CoreTeam',
    components: '',
    props: {},
    data () {
      return {
        activePerson: {},
        activePerson1: {},
        coreTeams: [
          {
            icon: require('../../../assets/img/aboutus/lwq.png'),
            bigImg: require('../../../assets/img/aboutus/lwq_big.png'),
            name: '卢威强',
            identity: '集团资深顾问',
            achievement: [
              '现新加坡绿柳资本管理公司主席兼总裁',
              '前新加坡政府投资机构董事总经理（企业战略）',
              '前新加坡政府投资机构亚洲区主管'
            ]
          }, {
            icon: require('../../../assets/img/aboutus/qx.png'),
            bigImg: require('../../../assets/img/aboutus/qx_big.png'),
            name: '钱兴',
            identity: '集团运营总监 CEO',
            achievement: [
              '新加坡南洋理工大学硕士',
              '高级知识产权运营策划师、咨询师',
              '前日本松下集团5G标准高级研发工程师'
            ]
          }, {
            icon: require('../../../assets/img/aboutus/wsg.png'),
            bigImg: require('../../../assets/img/aboutus/wsg_big.png'),
            name: '王水根',
            identity: '集团首席科学家 副总裁',
            achievement: [
              '北京理工大学博士',
              '美国德克萨斯大学奥斯汀分校访问学者',
              'ESI高被引论文作者'
            ]
          }, {
            icon: require('../../../assets/img/aboutus/cds.png'),
            bigImg: require('../../../assets/img/aboutus/cds_big.jpg'),
            name: '崔东顺',
            identity: '集团技术总监',
            achievement: [
              '新加坡南洋理工大学博士',
              '人工智能、机器学习和计算机视觉专家',
              '曾任南洋理工大学与宝马公司联合实验室算法设计师',
              '曾任南洋理工大学与Delta公司联合实验室算法设计师'
            ]
          }, {
            icon: require('../../../assets/img/aboutus/lqm.png'),
            bigImg: require('../../../assets/img/aboutus/lqm_big.jpg'),
            name: '李清明',
            identity: '集团工程高级副总裁',
            achievement: [
              '前英国西玛集团亚洲公司技术营销总监、首席顾问（电气及动力定位）、驻中国首席代表',
              '前美国船检局顾问公司 首席顾问（动力动态定位）教授级高工',
              '前三井海洋开发（新加坡）有限公司 高级电气主管工程师，机务监督，工作准证官员，项目代理经理',
              '前裕廊科技股份有限公司 总工程师兼基建工程总监'
            ]
          }, {
            icon: require('../../../assets/img/aboutus/fgq.png'),
            bigImg: require('../../../assets/img/aboutus/fgq_big.png'),
            name: '方高强',
            identity: '集团商务高级副总裁',
            achievement: [
              '前通用电气(GE)中国有限公司广东广西海南首席代表',
              '前VISA(中国)上海代表处代表'
            ]
          }
        ]
      }
    },
    methods: {
      openPersonDetail (item) {
        $('#person1').slideUp(300, () => {
          this.activePerson1 = {}
        })
        if (this.activePerson.name == item.name) {
          $('#person').slideUp(300, () => {
            this.activePerson = {}
          })
        } else {
          this.activePerson = item
          setTimeout(() => {
            $('#person').slideDown(300)
          }, 10)
        }
      },
      openPersonDetail1 (item) {
        $('#person').slideUp(300, () => {
          this.activePerson = {}
        })
        if (this.activePerson1.name == item.name) {
          $('#person1').slideUp(300, () => {
            this.activePerson1 = {}
          })
        } else {
          this.activePerson1 = item
          setTimeout(() => {
            $('#person1').slideDown(300)
          }, 10)
        }
      }
    },
    mounted () {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: false
      })
      wow.init()
    },
    computed: {
      getComponentName () {
        return 'CoreTeam'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .core-team {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 8rem;

    .title {
      font-size: 3rem;
      font-family: Arial,Source Han Sans CN;
      font-weight: 400;
      color: rgba(63, 74, 93, 1);
      line-height: 4.38rem;
    }

    .underline {
      max-width: 9.75rem;
      margin-top: 1.5rem;
    }

    .core-team-content {
      width: 100%;

      .content {
        display: flex;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .menu {
          display: flex;
          justify-content: space-between;
          max-width: 67.5rem;
          width: 100%;

          .item {
            cursor: pointer;

            .item-wrapper {
              width: 17.25rem;
              display: flex;
              align-items: center;

              .note {
                display: flex;
                flex-direction: column;
                margin-left: 1.5rem;

                .name {
                  font-size: 1.25rem;
                  font-family: Arial,Source Han Sans CN;
                  font-weight: bold;
                  color: rgba(63, 74, 93, 1);
                  letter-spacing: 0.15rem;
                }

                .identity {
                  font-size: 0.88rem;
                  font-family: Arial;
                  font-weight: 400;
                  color: rgba(63, 74, 93, 1);
                  line-height: 1.5rem;
                }
              }

              img {
                width: 6rem;
                height: 6rem;
              }
            }

            .triangle-up {
              width: 0;
              height: 0;
              border-left: 0.75rem solid transparent;
              border-right: 0.75rem solid transparent;
              border-bottom: 0.75rem solid rgba(232, 233, 238, 1);
              margin: 0.75rem 0 0 2.25rem;
              position: absolute;
              margin-top: 1.5rem;
            }

            .triangle-down {
              width: 0;
              height: 0;
              border-left: 0.75rem solid transparent;
              border-right: 0.75rem solid transparent;
              border-top: 0.75rem solid rgba(232, 233, 238, 1);
              margin: 0 0 0.75rem 2.25rem;
              position: absolute;
              margin-top: -1.5rem;
            }

            .item-wrapper:hover, .active {
              .name, .identity {
                color: #2B9EFF;
              }
            }
          }
        }
      }

      .peroson {
        position: relative;
        display: none;

        img {
          width: 100%;
        }

        .detail {
          position: absolute;
          top: 0;
          margin-left: 52.5%;
          margin-top: 7.5%;

          .name {
            font-size: 3rem;
            font-family: Arial,Source Han Sans CN;
            font-weight: 300;
            color: rgba(63, 74, 93, 1);
            line-height: 4.38rem;
            letter-spacing: 0.19rem;
          }

          .identity {
            font-size: 1.25rem;
            font-family: Arial,Source Han Sans CN;
            font-weight: bold;
            color: rgba(63, 74, 93, 1);
            line-height: 2.25rem;
            letter-spacing: 0.15rem;
          }

          .achievement {
            margin-top: 7%;
            font-size: 0.88rem;
            font-family: Arial,Source Han Sans CN;
            font-weight: 300;
            color: rgba(63, 74, 93, 1);
            line-height: 1.25rem;
            letter-spacing: 0.1rem;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/aboutus/CoreTeam.vue